import pro1 from "../assets/project1.png"
import pro2 from "../assets/project2.jpg"
import pro3 from "../assets/project3.jpg"

const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Ecommerce Website Design",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis nulla, quasi voluptatibus quas dolore ducimus corrupti eligendi vel, doloribus alias ratione id dicta laboriosam, perspiciatis cum? Ducimus exercitationem corporis natus!",
        view: "https://akshaybagai52.github.io/Ecommerce.github.io/"
    },

    {
        imgsrc: pro2,
        title: "Login Form",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis nulla, quasi voluptatibus quas dolore ducimus corrupti eligendi vel, doloribus alias ratione id dicta laboriosam, perspiciatis cum? Ducimus exercitationem corporis natus!",
        view: "https://akshaybagai52.github.io/LoginForm.github.io/"
    },

    {
        imgsrc: pro3,
        title: "Triangle generator with random colors",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis nulla, quasi voluptatibus quas dolore ducimus corrupti eligendi vel, doloribus alias ratione id dicta laboriosam, perspiciatis cum? Ducimus exercitationem corporis natus!",
        view: "https://akshaybagai52.github.io/PaintApp.github.io/"
    }
]

export default ProjectCardData;